import React from 'react'
import _ from 'lodash/fp'
import { connect } from 'react-redux'
import { graphql } from 'react-apollo'
import { Helmet } from 'react-helmet'

import colors from '@fe/ui/colors'

import { withStyles } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

import * as AnalyticsReducer from '../../reducers/analytics'

import { loader } from 'graphql.macro'
import Spinner from '@fe/ui/Spinner'

const productQuery = loader('./product.gql')

const styles = theme => ({
  price: {
    fontSize: '1.7em',
    color: colors.lightGreen
  },
  compareAtPrice: {
    fontSize: '1.7em',
    paddingRight: 8,
    color: theme.palette.text.primary,
    textDecoration: 'line-through'
  },
  offerContainer: {
    margin: 12,
    height: 'calc(100vh - 24px - 64px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'auto',
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      height: 'calc(100vh - 64px)'
    }
  },
  offerImageSize: {
    backgroundColor: colors.secondaryDarkGreyTransparent,
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    height: '60vh',
    width: '80vh',
    [theme.breakpoints.down('sm')]: {
      width: '100vw',
      height: '75vw'
    }
  },
  offerTextContainer: {
    marginTop: 24,
    width: '80vh',
    [theme.breakpoints.down('sm')]: {
      width: '100vw',
      padding: 12
    }
  },
  paddingRetard: {
    height: 0,
    [theme.breakpoints.down('sm')]: {
      height: 100
    }
  }
})

// const normalize = _.mapValues(v => _.has('edges', v) ? _.map(_.get('node'), _.get('edges', v)) : v)
const normalizeDeep = _.mapValues(v =>
  _.has('edges', v)
    ? _.map(
        _.flow(
          _.get('node'),
          normalizeDeep
        ),
        _.get('edges', v)
      )
    : v)

const Offer = ({ classes, book, data: { productByHandle, loading, error } }) => {
  const data = normalizeDeep(productByHandle)

  if (_.isEmpty(data)) {
    return <Spinner title='Loading offer...' />
  }

  const image = _.get('images.0.transformedSrc', data)
  const title = _.get('title', data)
  const vendor = _.get('vendor', data)
  const description = _.get('descriptionHtml', data)
  const comparePrice = _.flow(
    _.get('variants.0.compareAtPriceV2.amount'),
    _.round
  )(data)
  const price = _.flow(
    _.get('variants.0.priceV2.amount'),
    _.round
  )(data)
  const url = _.get('url.value', data)
  return (
    <>
      <Helmet>
        <title>{title} - my.GLFR Offers</title>
      </Helmet>
      <div className={classes.offerContainer}>
        <div
          className={classes.offerImageSize}
          style={{
            backgroundImage: `url(${image})`
          }}
        />
        <div className={classes.offerTextContainer}>
          <Typography variant='h5' component='h2'>
            {title}
          </Typography>
          <Typography variant='subtitle1' component='h2'>
            {_.toUpper(vendor)}
          </Typography>
          <Typography component='p' dangerouslySetInnerHTML={{ __html: description }} />
          {isNaN(comparePrice) ||
            <span className={classes.compareAtPrice}>{comparePrice} kr.</span>}
          <span className={classes.price}>
            {price} kr.
          </span>
          <a href={url}>
            <Button onClick={() => book(data)} style={{ marginTop: 24 }} fullWidth color='primary' variant='contained'>
              BOOK NOW
            </Button>
          </a>
        </div>
      </div>
      <div id='im-helping.png' className={classes.paddingRetard} />
    </>
  )
}

export default _.compose(
  withStyles(styles),
  connect(
    (_s, ownProps) => {
      return ({
        handle: _.get('match.params.productHandle', ownProps)
      })
    },
    (d) => ({
      book: (offer) => d(AnalyticsReducer.actions.book(offer))
    })
  ),
  graphql(productQuery)
)(Offer)
